import s from './mixProdutos/state'
import * as a from './mixProdutos/actions'
import * as m from './mixProdutos/mutations'
import * as g from './mixProdutos/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
